// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__tx4sW","label":"TextArea_label__++XDp","input":"TextArea_input__oOLXB","error_input":"TextArea_error_input__-Ap7i","error":"TextArea_error__MFxwg"};